import {
  ConditionBlock,
  FieldId,
  Filter,
  FilterOperator,
  LogicOperator,
  Primitive,
  QueryOptions,
  FilterDisplay,
  ConditionElement,
} from './types';
import { isBlank } from './GeneralUtils';

export const getConditionIdentityKey = (cond: ConditionElement): string | undefined => {
  if (!cond || typeof cond !== 'object') {
    return undefined;
  }
  const filter = cond as Filter;
  return [filter.fieldId, filter.operator, filter.value, filter.display].join('|');
};

export const getAutoCompleterSearchExpression = (conditionBlock: ConditionBlock, value: string): ConditionBlock => {
  const out: ConditionBlock = {};
  let replaced = false;
  if (typeof conditionBlock !== 'object') {
    throw new Error(`no autoCompleterSearchExpression provided for entity`);
  }
  (Object.keys(conditionBlock) as LogicOperator[]).forEach((oper) => {
    out[oper] = [];
    (conditionBlock[oper] || []).forEach((filter) => {
      const newFilter = Object.assign({}, filter);
      if ((newFilter as Filter).value === '[[SEARCH_TERM]]') {
        (newFilter as Filter).value = value;
        replaced = true;
      }
      (out[oper] || []).push(newFilter);
    });
  });
  if (!replaced) {
    console.error(`[[SEARCH_TERM]] token not found in QueryCondition`);
  }
  return out;
};

export const getFilter = (
  fieldId: FieldId,
  operator: FilterOperator,
  value: Primitive | Primitive[],
  display?: FilterDisplay,
): Filter => ({
  fieldId,
  operator,
  value,
  display,
});

export const getSimpleCondition = (fieldId: FieldId, value: string): ConditionBlock => ({
  and: [getFilter(fieldId, 'eq', value)],
});

export const getValueAndRemoveCondition = (queryOptions: QueryOptions, fieldId: string, defaultVal: any) => {
  let val = defaultVal;
  const andConditions = queryOptions.where?.and;
  const index =
    andConditions?.findIndex((cond: ConditionElement) => 'fieldId' in cond && cond.fieldId === fieldId) ?? -1;
  if (index > -1 && andConditions) {
    val = (andConditions[index] as Filter)?.value;
    andConditions.splice(index, 1); // remove
  }
  return val;
};

export const isApplicableFilter = (filter: Filter) => {
  return filter.operator === 'bl' || filter.operator === 'nb' || !isBlank(filter.value);
};

export const testFilter = (filter: Filter, value: Primitive): boolean => {
  const argValStrUpper = String(value).toUpperCase();
  const filtValStrUpper = String(filter.value).toUpperCase();
  if (filter.operator === 'bl') {
    return !value;
  } else if (filter.operator === 'nb') {
    return !!value;
  } else if (filter.operator === 'eq') {
    return isBlank(filter.value) || filter.value === value;
  } else if (filter.operator === 'ne') {
    return isBlank(filter.value) || filter.value !== value;
  } else if (filter.operator === 'ct') {
    return isBlank(filter.value) || argValStrUpper.indexOf(filtValStrUpper) > -1;
  } else if (filter.operator === 'sw') {
    // return argValStrUpper.indexOf(filtValStrUpper) === 0;
    return isBlank(filter.value) || argValStrUpper.substring(0, filtValStrUpper.length) === filtValStrUpper;
  } else if (filter.operator === 'ew') {
    // return argValStrUpper.indexOf(filtValStrUpper) === argValStrUpper.length - filtValStrUpper.length;
    return (
      isBlank(filter.value) ||
      argValStrUpper.substring(argValStrUpper.length - filtValStrUpper.length) === filtValStrUpper
    );
  } else if (filter.operator === 'gt') {
    const filterValue = filter.value as Primitive;
    return isBlank(filterValue) || (!!value && filterValue != null && (value as any) > filterValue);
  } else if (filter.operator === 'lt') {
    const filterValue = filter.value as Primitive;
    return isBlank(filterValue) || (!!value && filterValue != null && (value as any) < filterValue);
  } else if (filter.operator === 'ia') {
    const filterValues = Array.isArray(filter.value) ? filter.value : [filter.value];
    const values = (Array.isArray(value) ? value : []) as Primitive[];
    return filterValues.length === 0 || filterValues.some((filterValue) => values.includes(filterValue));
  } else {
    throw new Error(`unsupported operator: ${filter.operator}`);
  }
};
